import React, { Component } from 'react'
import { connect } from 'react-redux'
import { app } from "../../../../../../../config/constants";
import Toggle from 'material-ui/Toggle';

class PromotionVariantActionsBottom extends Component {
	constructor(props) {
		super(props);

		this.state = {
			views: 0,
			clicks: 0,
		}
	}

	componentDidMount() {
		const variantKey = this.props.promotion.periods[this.props.periodKey].variants[this.props.variantKey].key;
		let views = 0;
		let clicks = 0;

		if ( undefined !== variantKey ) {
			app.database().ref( 'cams/statistics/simple/views' ).child(variantKey).once( 'value', ( viewsSnap ) => {


				if ( null !== viewsSnap.val() ) {
					views = viewsSnap.val().views;
				}

				this.setState({
					views: views
				})
			});

			app.database().ref( 'cams/statistics/simple/clicks' ).child(variantKey).once( 'value', ( clicksSnap ) => {
				if ( null !== clicksSnap.val() ) {
					clicks = clicksSnap.val().clicks;
				}

				this.setState({
					clicks: clicks
				})	
			});
		}
	}

	render() {

		let ctr = ( this.state.clicks / this.state.views ) * 100;

		return (
			<div className="grid-x grid-margin-y grid-padding-x grid-margin-x">
				<div className="medium-6 cell">
					Views: {this.state.views} Clicks: {this.state.clicks} CTR: {ctr.toFixed(2)}%
				</div>
			</div>

		);
	}
}

const mapStateToProps = ( state ) => {
	return {
		promotion: state.promotion
	}
};

export default connect(mapStateToProps)(PromotionVariantActionsBottom)


// WEBPACK FOOTER //
// ./src/application/components/promotions/components/types/variants/includes/actionsBottom.js